import { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import DropdownNew from "utils/dropdown";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import Pagination from "components/__new/common/pagination";
import Maybe from "components/__new/common/Maybe";
import processParams from "utils/processParams";
import DialogBox from "utils/dialogBox";
import useMultiSelect from "hooks/useMultiSelect";
import useLoginInfo from "hooks/useLoginInfo";
import { TableContent } from "components/__new/common/TableContent";
import PayScheduleForm from "components/__new/payroll/PayScheduleForm";
import logger from "utils/logger";
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import { DateFormat } from "utils/dateFormat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";
import * as payrollSetupAction from "store/entities/payroll/payrollSetup/action";
import DeletePaySchedule from "../../../components/__new/payroll/DeletePaySchedule";
import ViewPayScheduleDetails from "../../../components/__new/payroll/ViewPayScheduleDetails";
import { frequencyDisplay } from "utils/payroll/frequencyDisplay";
import Filter, { ActiveFilter } from "components/__new/common/Filter";


export const List = () => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const {urlQueryParams} = useUrlQueryParams();
    const { selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections } = useMultiSelect();
    const {getPayScheduleData: paySchedules, getPayScheduleLoading: paySchedulesLoading, deleteMultipleSchedulesLoading, deletePayScheduleResponse, deletePayScheduleLoading} = useSelector(state => state.entities.payrollSetup);
    
    const printComponentRef = useRef();
    const [isOpenPayScheduleForm, setisOpenPayScheduleForm] = useState(false);
    const [isOpenDeletePaySchedule, setIsOpenDeletePaySchedule] = useState(false);
    const [paySchedule, setPaySchedule] = useState({});
    const [isOpenPayScheduleDetails, setIsOpenPayScheduleDetails] = useState();
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });

    
    const getPaySchedules = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");
        params = processParams(urlQueryParams, params, "dateRange", "string", "", "dateRange"); 
        // params = processParams(urlQueryParams, params, "frequency", "string", "", "frequency");

        setListParams(params);
        dispatch(payrollSetupAction.getPaySchedule(params));
    }
    
    
    const createSchedule = () => {
        logger("Employer-Payroll-setup-payschedule-attempt", userInfo);
        setPaySchedule({});
        setisOpenPayScheduleForm(true);
    }

    
    const editSchedule = (e) => {
        setPaySchedule(e);
        setisOpenPayScheduleForm(true);
    }
    
    
    const deleteSchedule = async () => {
        dispatch(payrollSetupAction.deletePaySchedule(paySchedule.id));
        // toast.success('Pay schedule successfully deleted');
        // const result = await DialogBox({
		// 	title: "Delete Pay Schedule 😰",
		// 	content: <div className="delete-modal-text">Are you sure you want to delete this pay schedule? This action cannot be undone.</div>,
		// 	buttonYes: "Delete",
        //     buttonYesClass: "btn-ep-red",
		// 	buttonNo: "Cancel",
		// });
		// if (result) {
        //     dispatch(payrollSetupAction.deletePaySchedule(schedule.id));
        // }
    }

    
    const bulkDeleteSchedule = async () => {
        const result = await DialogBox({
			title: "Delete Pay Schedules 😰",
			content: <div className="delete-modal-text">Are you sure you want to delete {selections?.length} pay schedules? This action cannot be undone.</div>,
			buttonYes: "Delete Selected",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            const selectedIds = selections.map((selection) => JSON.parse(selection).id);
            // console.log("selectedIds", selectedIds);
            dispatch(payrollSetupAction.deleteMultiplePaySchedules({ids: selectedIds}));
        }
    }
    
    const handleTogglePayScheduleForm = () => {
        setisOpenPayScheduleForm(!isOpenPayScheduleForm);
    }
    
    const paginationData = useMemo(() => {
        if (!paySchedules?.data) return {};
        
        const { data, ...paginationInfo } = paySchedules;
        return paginationInfo;
    }, [paySchedules])
    
    useEffect(() => {
        getPaySchedules();
        // eslint-disable-next-line
    }, [location]);
    
    
    useEffect(() => {
        if ((deletePayScheduleResponse?.id !== "" && typeof deletePayScheduleResponse?.id === "string") || (deletePayScheduleResponse?.count !== undefined && typeof deletePayScheduleResponse?.count === "number")){
            history.push({ ...urlQueryParams, page: 1 });
            // getPaySchedules();
            clearSelections();
            setIsOpenDeletePaySchedule(false);
        }
        // eslint-disable-next-line
    }, [deletePayScheduleResponse]);
    
    
    return (
        <div>

            <DynamicHeadTag
                headerText="Pay Schedule"
                headerDescription="Optimize your payment management by configuring specific dates and intervals for employee salaries and wages with our flexible pay schedule feature"
            />
            
            <PayScheduleForm
                isOpen={isOpenPayScheduleForm}
                setIsOpen={setisOpenPayScheduleForm}
                paySchedule={paySchedule}
                getPaySchedules={getPaySchedules}
            />
            
            <ViewPayScheduleDetails
                isOpen={isOpenPayScheduleDetails}
                setIsOpen={setIsOpenPayScheduleDetails}
                paySchedule={paySchedule}
                handleTogglePayScheduleForm={handleTogglePayScheduleForm}
            />
            
            <DeletePaySchedule
                loading={deletePayScheduleLoading}
                isOpen={isOpenDeletePaySchedule}
                setIsOpen={setIsOpenDeletePaySchedule}
                onProceed={deleteSchedule}
            />
            
            <div className="box !px-0 !pb-0">
                <div className="px-6 font-medium text-xl">
                    Pay Schedules
                </div>
                
                <div className={`px-6 mt-6 xl:flex flex-wrap ${selections?.length > 0 ? "justify-start" : "justify-between"}`}>
                    <div className="flex-grow flex items-center">
                        <div className="flex mr-4">
                            <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleMultiSelectHeader} />
                        </div>
                        {/* <div className="w-10 flex justify-center items-center">
                            <IconDotH className="h-6 svg-fill-ccc" />
                        </div> */}
                        <Maybe condition={selections?.length > 0}>
                            <div className="flex flex-wrap items-center">
                                <button type="button" onClick={bulkDeleteSchedule} className="dropdown-item dropdown-item-icon text-red-500" disabled={deleteMultipleSchedulesLoading}>
                                    <Maybe condition={deleteMultipleSchedulesLoading === true}>
                                        <FontAwesomeIcon icon="circle-notch" spin className="text-xl" style={{margin: "auto 0.5rem auto 0"}} />
                                    </Maybe>
                                    <Maybe condition={deleteMultipleSchedulesLoading === false}>
                                        <IconTrash style={{height: "1.25rem", marginRight: "0.5rem"}} />
                                    </Maybe>
                                    Delete
                                </button>

                                <div className="mx-2 sm:mx-6">
                                    <div className="w-0.5 h-4 bg-gray-200"></div>
                                </div>

                                <div className="flex space-x-4">
                                    <div className="text-[#6C757D]">
                                        {selections?.length} selected
                                    </div>
                                    <button type="button" onClick={clearSelections}>
                                        <IconsTimes className="svg-fill-red" />
                                    </button>
                                </div>
                            </div>
                        </Maybe>
                        <Maybe condition={selections?.length === 0}>
                            <div className="w-full max-w-sm sm:mr-6">
                                <SearchBox placeholder="Search Pay Schedule" name="search" extraUrlParams="page=1" />
                            </div>
                        </Maybe>
                    </div>
                    <Maybe condition={selections?.length === 0}>
                        <div className="mt-2 xl:mt-0 flex flex-wrap space-x-3">
                            <div>
                                <Filter 
                                    filters={[
                                        {
                                            title: "Date range",
                                            name: "dateRange",
                                            dataType: "custom-timeframe",
                                            hasResetButton: true,
                                            options: [
                                                {
                                                    display: "Today",
                                                    payload: "today",
                                                },
                                                {
                                                    display: "Last 7 days",
                                                    payload: "last_7_days",
                                                },
                                                {
                                                    display: "30 days",
                                                    payload: "30_days",
                                                },
                                                {
                                                    display: "1 Year",
                                                    payload: "1_year",
                                                },
                                            ],
                                        },
                                        {
                                            title: "Custom date range",
                                            dataType: "date-range",
                                            options: {
                                                from: {
                                                    name: "startDate",
                                                    placeholder: "Start Date",
                                                },
                                                to: {
                                                    name: "endDate",
                                                    placeholder: "End Date",
                                                },
                                            },
                                        },
                                        /* {
                                            title: "Payroll frequency",
                                            name: "frequency",
                                            dataType: "select",
                                            options: [
                                                {
                                                    display: "Monthly",
                                                    payload: "MONTHLY",
                                                },
                                                {
                                                    display: "Bi-Monthly",
                                                    payload: "BI_MONTHLY",
                                                },
                                                {
                                                    display: "Weekly",
                                                    payload: "WEEKLY",
                                                },
                                            ],
                                        }, */
                                    ]}
                                />
                            </div>
                            <div>
                                <button onClick={createSchedule} type="button" className="btn btn-md btn-ep-primary">
                                    <FontAwesomeIcon icon="plus" className="mr-2" />
                                    Create Pay Schedule
                                </button>
                            </div>

                            {/* <div>
                                <Print component={printComponentRef} />
                            </div> */}
                        </div>
                    </Maybe>
                </div>

                <div className="px-6">
                    <ActiveFilter 
                        filters={{
                            "Date range": "dateRange",
                            "Period start date": "startDate", 
                            "Period end date": "endDate",
                            "Payroll frequency": "frequency",
                        }} 
                    />
                </div>
                
                <div className="mt-6">
                    <div ref={printComponentRef}>
                        
                        <div className="mb-4 text-xl hidden print:block">
                            Pay Schedules
                        </div>
                        
                        
                        <Table>
                            <Table.Head>
                                <th style={{ paddingRight: 0, paddingLeft: "1.5rem" }}></th>
                                <th style={{ paddingLeft: 0 }}>Schedule Name</th>
                                <th>Date Created</th>
                                <th>Pay Schedule Frequency</th>
                                <th></th>
                            </Table.Head>
                            <Table.Body>

                                <TableContent
                                    loading={paySchedulesLoading || deleteMultipleSchedulesLoading}
                                    loadingText={`${deleteMultipleSchedulesLoading ? "Deleting Multiple Pay Schedules" : "Fetching Pay Schedules"}`}
                                    data={paySchedules?.data || []}
                                    total={paySchedules?.data?.length}
                                    colspan={5}
                                    emptyUI={<>
                                        <div className="py-20 mx-auto text-center text-base">
                                            <div className="flex justify-center">
                                                <img src={IconEmptyBox} alt="Empty" className="h-48" />
                                            </div>
                                            <div className="text-[#101828] font-medium">
                                                No Data Available
                                            </div>
                                            <div onClick={createSchedule} className="mt-1 underline cursor-pointer text-[#4A5564]">
                                                Click here to create pay schedule
                                            </div>
                                        </div>
                                    </>}
                                    
                                />

                                {(!paySchedulesLoading && !deleteMultipleSchedulesLoading) && paySchedules?.data?.map((schedule, index) => 
                                    <tr key={index}>
                                        <td style={{ paddingRight: "15px", paddingLeft: "1.5rem", width: "20px" }}>
                                            <input
                                                type="checkbox"
                                                className="form-checkbox w-5 h-5 multi-select"
                                                onChange={getMultiSelectBody}
                                                checked={selections?.filter((selection) => JSON.parse(selection).id === schedule.id).length === 1}
                                                value={JSON.stringify(schedule)}
                                            />
                                        </td>
                                        <td className="td-word-break" style={{ paddingLeft: 0, width: "350px" }}>
                                            {schedule?.name}
                                        </td>
                                        <td>
                                            {DateFormat(schedule?.createdAt)}
                                        </td>
                                        <td className="capitalize">
                                            {frequencyDisplay(schedule?.frequency?.payroll_frequency)}
                                        </td>
                                        <td>
                                            <DropdownNew iconClassName="rotate-90">
                                                <></>
                                                <div>
                                                    <div onClick={() => {
                                                        setPaySchedule(schedule);
                                                        setIsOpenPayScheduleDetails(true);
                                                    }} className="dropdown-item">View</div>
                                                    <div onClick={() => editSchedule(schedule)} className="dropdown-item">Edit</div>
                                                    <div onClick={() => {
                                                        setPaySchedule(schedule)
                                                        setIsOpenDeletePaySchedule(true)
                                                    }} className="dropdown-item text-red-500">Delete</div>
                                                </div>
                                            </DropdownNew>
                                        </td>
                                    </tr>
                                )}

                            </Table.Body>
                        </Table>

                        <Maybe condition={paySchedulesLoading === false && paySchedules?.data?.length > 0}>
                            <div className="mt-6">
                                <Pagination data={paginationData} limit={paginationData?.limit} />
                            </div>
                        </Maybe>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default List;